import { AxiosAdapter } from '../commons/adapters';
import { QueryPagination } from '../commons/interfaces';
import { buildQuery } from '../commons/utils/helpers';
import { IKnowledgeBase } from '../commons/interfaces/knowledge-base.interface';

const http = new AxiosAdapter();
const BASE_URL = '/v1/knowledge-bases';

export const getAllKnowledgeBasesService = async (query?: QueryPagination) => {
  try {
    return await http.get<any>(`${BASE_URL}?${buildQuery(query)}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getAllKnowledgeBasesService error', error);
  }
};

export const getFormToDropdownService = async () => {
  try {
    return await http.get<any>(`${BASE_URL}/form`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getFormToDropdownService error', error);
  }
};

export const getKnowledgeBaseByIdService = async (id: string) => {
  try {
    return await http.get<any>(`${BASE_URL}/${id}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getKnowledgeBaseByIdService error', error);
  }
};

export const createKnowledgeBaseService = async (
  data: IKnowledgeBase | FormData,
  setPercentageUpload?: any
) => {
  try {
    return await http.post<any>(BASE_URL, data, setPercentageUpload);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('createKnowledgeBaseService error', error);
  }
};

export const updateKnowledgeBaseService = async (
  id: string,
  data: Partial<IKnowledgeBase>,
  query?: QueryPagination,
  setPercentageUpload?: any
) => {
  try {
    return await http.put<any>(`${BASE_URL}/${id}?${buildQuery(query)}`, data, setPercentageUpload);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('updateKnowledgeBaseService error', error);
  }
};

export const deleteKnowledgeBaseService = async (id: string, query?: QueryPagination) => {
  try {
    return await http.deleteTable<any>(`${BASE_URL}/${id}?${buildQuery(query)}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('deleteKnowledgeBaseService error', error);
  }
};

export const restoreKnowledgeBaseService = async (id: string, query?: QueryPagination) => {
  try {
    return await http.patchTable<any>(`${BASE_URL}/${id}/restore?${buildQuery(query)}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('restoreKnowledgeBaseService error', error);
  }
};
